import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';
import { CurrencyPipe, getCurrencySymbol } from '@angular/common';

@Injectable({ providedIn: 'root' })
@Pipe({ standalone: true, name: 'currencyFormat' })

export class CurrencyFormatPipe implements PipeTransform {
	constructor(private currencyPipe: CurrencyPipe) {}

	public transform(value: number): string {
		if (value === null) return null;

		return this.currencyPipe.transform(
			value,
			environment.currency.code,
			getCurrencySymbol(environment.currency.code, 'narrow', environment.currency.locale),
			'1.2-2',
			environment.currency.locale
		);
	}
}